import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import SectionHeader from './SectionHeader';
import { SvgIconComponent } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import {
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string | React.ReactNode;
  icon: SvgIconComponent;
  colorClass?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isProcessing?: boolean;
}

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  icon,
  colorClass = 'bg-[#ff7500]',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  isProcessing = false,
}: ConfirmationModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1.5,
        },
      }}
    >
      <DialogContent sx={{ pb: 1 }}>
        <div className='flex flex-col'>
          <SectionHeader title={title} icon={icon} colorClass={colorClass} />

          <div className='text-gray-600 text-[16px] leading-relaxed font-medium px-1'>
            {description}
          </div>
        </div>
      </DialogContent>

      <DialogActions className='px-6 pb-6 gap-3'>
        <GlobalButton
          action={onClose}
          variant={GlobalButtonVariant.secondaryButton}
          disabled={isProcessing}
        >
          {cancelLabel}
        </GlobalButton>
        <GlobalButton
          action={onConfirm}
          variant={GlobalButtonVariant.primaryButton}
          disabled={isProcessing}
        >
          {confirmLabel}
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
